<template>
  <div
    class="player_double"
    :style="{ width: width, '--mixtmt_mixvw': cssDynamicObj.mixvw }"
  >
    <div class="playerList">
      <div class="playerItem" v-for="item in playerInfos" :key="item.playerId">
        <div class="img-box" :class="item.profilePicture ? 'isLogo' : ''">
          <img :src="item.profilePicture" alt="" />
        </div>
        <div class="name-box">
          <span v-if="!!item.shirtNumber"></span>
          <span v-text="item.playerName"></span>
          <span
            v-if="!!item.personNameEn"
            v-text="`(${item.personNameEn})`"
          ></span>
        </div>
      </div>
    </div>
    <div class="country-box">
      <span
        class="country_logo"
        :style="{ width: countryLogoSize[0], height: countryLogoSize[1] }"
      >
        <img :src="countryImg" alt="" />
      </span>
      <span class="country-name" v-text="countryName"></span>
    </div>
  </div>
</template>

<script>
// 球员信息
export default {
  props: {
    // 必传参数，球员姓名
    playerInfos: {
      type: Array,
      default: () => {
        return []
      },
    },
    // 必传参数，国家图片
    countryImg: {
      type: String,
      default: '',
    },
    // 必传参数，国家中文名
    countryName: {
      type: String,
      default: '',
    },
    width: {
      type: String,
      default: 'calc(7.64vw * var(--mixtmt_mixvw))',
    },
    countryLogoSize: {
      type: Array,
      default: () => {
        return [
          'calc(2.498vw * var(--mixtmt_mixvw))',
          'calc(1.666vw * var(--mixtmt_mixvw))',
        ] //['2.498vw', '1.666vw']
      },
    },
    cssDynamicObj: {
      type: Object,
      default: () => ({
        mixvw: 1,
        mixvh: 1,
        realyWidth: 0,
        realyHeight: 0,
      }),
    },
  },
  data() {
    return {}
  },
}
</script>

<style lang="scss" scoped>
.player_double {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: column;
  width: calc(7.64vw * var(--mixtmt_mixvw));
  .playerList {
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: space-between;
    align-items: center;
    .playerItem {
      width: calc(50% - 1px - 1px);
      display: flex;
      display: -webkit-flex;
      justify-content: flex-start;
      align-items: center;
      flex-direction: column;
      .img-box {
        position: relative;
        width: 100%;
        height: calc(8.33vw * var(--mixtmt_mixvw));
        background-size: 100% auto;
        background-size: cover;
        background-repeat: no-repeat;
        background-position: center bottom;
        background-image: var(--mixtmt_default_playerLogo);
        &::before {
          content: '\20';
          position: absolute;
          left: 0;
          top: 0;
          z-index: 2;
          width: 100%;
          height: 100%;
          border: 1px solid var(--mixtmt_greyColor5);
        }
        &.isLogo {
          background-image: none;
        }
        img {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
      .name-box {
        width: 100%;
        margin: calc(0.556vw * var(--mixtmt_mixvw)) 0
          calc(0.833vw * var(--mixtmt_mixvw)) 0;
        font-size: calc(0.972vw * var(--mixtmt_mixvw));
        color: var(--mixtmt_greyColor_main);
        line-height: calc(1.25vw * var(--mixtmt_mixvw));
        text-align: center;
        text-overflow: ellipsis;
        white-space: nowrap;
        overflow: hidden;
      }
    }
  }
  .country-box {
    width: 100%;
    height: auto;
    display: flex;
    display: -webkit-flex;
    justify-content: center;
    align-items: center;
    .country_logo {
      position: relative;
      /* width: 2.498vw;
      height: 1.666vw; */
      margin-right: calc(0.694vw * var(--mixtmt_mixvw));
      overflow: hidden;
      &::before {
        content: '\20';
        position: absolute;
        left: 0;
        top: 0;
        z-index: 2;
        width: 100%;
        height: 100%;
        border: 1px solid var(--mixtmt_greyColor5);
      }
    }
    img {
      display: block;
      width: 100%;
      height: 100%;
      object-fit: contain;
    }
    .country-name {
      font-size: calc(0.972vw * var(--mixtmt_mixvw));
      color: var(--mixtmt_greyColor_main);
      line-height: calc(1.666vw * var(--mixtmt_mixvw));
      vertical-align: top;
    }
  }
}
</style>
